<template>
  <form
    ref="form"
    @submit.prevent="next"
  >
    <c-title>Antragsformular</c-title>

    <p class="mt-8 mb-8">
      Alle Felder außer den explizit ausgenommenen sind Pflichtfelder.
    </p>
    <c-form-fieldset
      legend="Antragssteller:in"
      class="mb-8"
    >
      <c-form-text
        v-model="fields.applicant1_name"
        :errors="errors.applicant1_name"
        class="mb-8"
        label="(Titel) Name von Antragssteller:in 1"
        required
      />
      <c-form-text
        v-model="fields.applicant1_function"
        :errors="errors.applicant1_function"
        class="mb-8"
        label="Funktion"
        required
      />
      <c-form-text
        v-model="fields.applicant1_email"
        :errors="errors.applicant1_email"
        class="mb-8"
        label="E-Mail-Adresse"
        type="email"
        autocomplete="email"
        required
      />
      <c-form-text
        v-model="fields.applicant1_phone"
        :errors="errors.applicant1_phone"
        class="mb-8"
        label="Telefonnummer"
        autocomplete="tel"
        required
      />
      <br>
      <c-form-text
        v-model="fields.applicant2_name"
        :errors="errors.applicant2_name"
        class="mb-8"
        label="(Titel) Name von Antragssteller:in 2 (falls vorhanden)"
      />
      <c-form-text
        v-model="fields.applicant2_function"
        :errors="errors.applicant2_function"
        class="mb-8"
        label="Funktion"
        :required="fields.applicant2_name !== ''"
      />
      <c-form-text
        v-model="fields.applicant2_email"
        :errors="errors.applicant2_email"
        class="mb-8"
        label="E-Mail-Adresse"
        type="email"
        :required="fields.applicant2_name !== ''"
      />
      <c-form-text
        v-model="fields.applicant2_phone"
        :errors="errors.applicant2_phone"
        class="mb-8"
        label="Telefonnummer"
        :required="fields.applicant2_name !== ''"
      />
      <br>
      <c-form-text
        v-model="fields.university"
        :errors="errors.university"
        class="mb-8"
        label="Hochschule"
        required
      />
      <c-form-text
        v-model="fields.faculty"
        :errors="errors.faculty"
        class="mb-8"
        label="Fakultät / Dekanat / Zentrale Einrichtung"
        tag="textarea"
        maxlength="300"
        rows="3"
        required
      />
      <c-form-text
        v-model="fields.department"
        :errors="errors.department"
        class="mb-8"
        label="Fachbereich / Institut / Department"
        tag="textarea"
        maxlength="300"
        rows="3"
        required
      />
      <c-form-text
        v-model="fields.address"
        :errors="errors.address"
        class="mb-8"
        label="Straße und Hausnummer"
        required
      />
      <c-form-columns :columns="[1, 5]">
        <c-form-text
          v-model="fields.postal_code"
          :errors="errors.postal_code"
          class="mb-8"
          label="Postleitzahl"
          inputmode="numeric"
          pattern="[0-9]*"
          minlength="5"
          maxlength="5"
          required
        />
        <c-form-text
          v-model="fields.city"
          :errors="errors.city"
          class="mb-8"
          label="Ort"
          required
        />
      </c-form-columns>
    </c-form-fieldset>
    <c-form-fieldset
      legend="Angaben zum Projekt"
      class="mb-8"
    >
      <c-form-text
        v-model="fields.project_title"
        :errors="errors.project_title"
        class="mb-8"
        label="Projekttitel"
        tag="textarea"
        maxlength="200"
        rows="3"
        required
      />
      <c-form-text
        v-model="fields.event_dates"
        :errors="errors.event_dates"
        class="mb-8"
        label="Zeitraum"
        required
      />
      <c-form-text
        v-model="fields.target_group"
        :errors="errors.target_group"
        class="mb-8"
        label="Zielgruppe(n) des Projekts"
        tag="textarea"
        maxlength="300"
        rows="3"
        required
      />
      <c-form-text
        v-model="fields.further_involved"
        :errors="errors.further_involved"
        class="mb-8"
        label="Weitere Projektbeteiligte / Kooperationspartner:innen (kein Pflichtfeld)"
      />
      <c-form-text
        v-model="fields.message_text"
        :errors="errors.message_text"
        class="mb-8"
        label="Kurzbeschreibung des Projekts"
        :help="`max. 1500 Zeichen, inkl. Leerzeichen`"
        required
        tag="textarea"
        maxlength="1500"
        rows="20"
      />
    </c-form-fieldset>
    <c-form-fieldset
      legend="Kosten/Finanzierung"
      class="mb-8"
    >
      <c-form-text
        v-model="fields.total_cost"
        :errors="errors.total_cost"
        class="mb-8"
        label="Gesamtkosten"
        required
      />
      <c-form-text
        v-model="fields.secured_funds"
        :errors="errors.secured_funds"
        class="mb-8"
        label="Anderweitig beantragte und/oder bewilligte Mittel (kein Pflichtfeld)"
      />
      <c-form-text
        v-model="fields.application_amount"
        :errors="errors.application_amount"
        class="mb-8"
        label="Antragssumme Claussen-Simon-Stiftung"
        required
      />
      <c-form-text
        :errors="errors.project_description"
        class="mt-5 mb-8"
        type="file"
        :file="fields.project_description"
        label="Projektbeschreibung inkl. Durchführungskonzept, Zeitplan und Beschreibung der Situation und Ausstattung der Hochschule (2-4 Seiten)"
        :help="`Erlaubte Dateiendungen: PDF, DOC, DOCX, XLS und XLSX. Maximale Dateigröße: 5 MB.`"
        accept=".pdf,.doc,.docx,.xls,.xlsx"
        required
        @change="fields.project_description = $event"
      />
      <c-form-text
        :errors="errors.cost_plan_file"
        class="mt-5 mb-8"
        type="file"
        :file="fields.cost_plan_file"
        label="Kosten- & Finanzierungsplan"
        :help="`Erlaubte Dateiendungen: PDF, DOC, DOCX, XLS und XLSX. Maximale Dateigröße: 5 MB.`"
        accept=".pdf,.doc,.docx,.xls,.xlsx"
        required
        @change="fields.cost_plan_file = $event"
      />
      <c-form-text
        :errors="errors.media_center_confirmation"
        class="mt-5 mb-8"
        type="file"
        :file="fields.media_center_confirmation"
        label="Bedarfsbestätigung des Medien- bzw. Rechenzentrums, falls das Projekt auch die Anschaffung von Hard- und Software beinhaltet (kein Pflichtfeld)"
        :help="`Erlaubte Dateiendungen: PDF, DOC, DOCX, XLS und XLSX. Maximale Dateigröße: 5 MB.`"
        accept=".pdf,.doc,.docx,.xls,.xlsx"
        @change="fields.media_center_confirmation = $event"
      />
    </c-form-fieldset>
    <c-button>
      Nächster Schritt
    </c-button>
  </form>
</template>

<script>
import BRequestStep from './BRequestStep.vue'

export default {
  name: 'VRequestStep0',

  extends: BRequestStep,

  data () {
    return {
      fields: {
        applicant1_name: '',
        applicant1_function: '',
        applicant1_email: '',
        applicant1_phone: '',
        applicant2_name: '',
        applicant2_function: '',
        applicant2_email: '',
        applicant2_phone: '',
        university: '',
        faculty: '',
        department: '',
        address: '',
        postal_code: '',
        city: '',
        project_title: '',
        event_dates: '',
        target_group: '',
        further_involved: '',
        message_text: '',
        total_cost: '',
        secured_funds: '',
        application_amount: '',
        project_description: '',
        cost_plan_file: '',
        media_center_confirmation: ''
      }
    }
  },

  computed: {
    step: () => 0,
    id: () => 'reportData'
  }
}
</script>

<style lang="scss" scoped>
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>
